import { API, setAuthToken } from '../../../config/API.js';
import {
  GET_DATA_KOMITE,
  GET_KATEGORI_KOMITE,
  SET_LOADING_DATA_KOMITE,
  SET_LOADING_KATEGORI_KOMITE,
  SET_PAGINATION_DATA_KOMITE,
  SET_PAGINATION_KATEGORI_KOMITE,
} from '../constant.js';

export const getKategoriKomite = (params) => {
  return (dispatch) => {
    const token = localStorage.getItem("jwt_token");
    setAuthToken(token);
    dispatch({
      type: SET_LOADING_KATEGORI_KOMITE,
      payload: true,
    });
    API.get(`admin/gcg/committee/cat?${new URLSearchParams(params).toString()}`)
      .then((res) => {
        dispatch({
          type: GET_KATEGORI_KOMITE,
          payload: params?.paginate === false ? res?.data : res.data.data || [],
        });
        dispatch({
          type: SET_PAGINATION_KATEGORI_KOMITE,
          payload: res?.data?.data?.last_page,
        });
      })
      .catch(() => {
        dispatch({
          type: GET_KATEGORI_KOMITE,
          payload: [],
        });
        dispatch({
          type: SET_PAGINATION_KATEGORI_KOMITE,
          payload: 0,
        });
      });
  };
};

export const addKategoriKomite = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/gcg/committee/cat/add", params);
};

export const getDetailKategoriKomite = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.get(`admin/gcg/committee/cat/${code}`);
};

export const updKategoriKomite = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/gcg/committee/cat/edit", params);
};

export const delKategoriKomite = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.delete("admin/gcg/committee/cat/delete/" + code);
};

export const getDataKomite = (params) => {
  return (dispatch) => {
    const token = localStorage.getItem("jwt_token");
    setAuthToken(token);
    dispatch({
      type: SET_LOADING_DATA_KOMITE,
      payload: true,
    });
    API.get(`admin/gcg/committee?${new URLSearchParams(params).toString()}`)
      .then((res) => {
        dispatch({
          type: GET_DATA_KOMITE,
          payload: res.data.data || [],
        });
        dispatch({
          type: SET_PAGINATION_DATA_KOMITE,
          payload: res?.data?.data?.last_page,
        });
      })
      .catch(() => {
        dispatch({
          type: GET_DATA_KOMITE,
          payload: [],
        });
        dispatch({
          type: SET_PAGINATION_DATA_KOMITE,
          payload: 0,
        });
      });
  };
};

export const addDataKomite = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/gcg/committee/add", params);
};

export const getDetailDataKomite = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.get(`admin/gcg/committee/${code}`);
};

export const updDataKomite = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/gcg/committee/edit", params);
};

export const delDataKomite = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.delete("admin/gcg/committee/delete/" + code);
};
